// ------------------------------------
// Constants
// ------------------------------------
export const ORGANIZATIONS_GET_REQUEST = "ORGANIZATIONS_GET_REQUEST";
export const ORGANIZATIONS_GET_REQUEST_SUCCESS =
  "ORGANIZATIONS_GET_REQUEST_SUCCESS";
export const ORGANIZATIONS_GET_REQUEST_FAILURE =
  "ORGANIZATIONS_GET_REQUEST_FAILURE";
export const ORGANIZATIONS_GET_RESET = "ORGANIZATIONS_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(searchParams) {
  return {
    type: ORGANIZATIONS_GET_REQUEST,
    searchParams,
  };
}

export function requestSuccess(res) {
  return {
    type: ORGANIZATIONS_GET_REQUEST_SUCCESS,
    data: res,
  };
}

export function requestFailure(error) {
  return {
    type: ORGANIZATIONS_GET_REQUEST_FAILURE,
    error,
  };
}

export function reset() {
  return {
    type: ORGANIZATIONS_GET_RESET,
  };
}
